import React, { useState, useEffect } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "../Input/constantInput/constantInput";

const EmployeeCreditFilter = ({ applyFilter }) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.employeeFilterData || "{}");
      return {
        employee_name: data.employee_name || "",
      };
    } catch {
      return {
        employee_name: "",
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    employee_name: initialFilterInputs.employee_name,
  });

  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
      employee_name: storedData.employee_name ? storedData.employee_name : "",
    });
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
          employee_name: filterFieldsData.employee_name ? filterFieldsData.employee_name : "",
        });
      }}
    >
      <ConstantInput
        label={"Employee Name"}
        value={window.localStorage?.employee_credit_filter && window.localStorage?.employee_credit_filter ? JSON.parse(window.localStorage?.employee_credit_filter)['employee_name'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, employee_name: val });
        }}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              employee_name: "",
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default EmployeeCreditFilter;
